/* ========================== */  
/* ========= import ========= */  
/* ========================== */


/* ============================ */  
/* ========= コード定義 ========= */  
/* ============================ */  

/* ========= 画面コードマスタ ========= */
export const screenMaster = [
    { id:'GetAuth',                     path:'/',                                   auth:''},//認証・認可
    { id:'GetApprovalList',             path:'/employee/approval/list',             auth:'approval'},//人事稟議一覧
    { id:'GetInformationDetail',        path:'/employee/information/detail',        auth:'information'},//従業員詳細
    { id:'GetInformationList',          path:'/employee/information/list',          auth:'information'},//従業員一覧
    { id:'GetInformationFormat',        path:'/employee/information/format',        auth:'information'},//従業員一括編集 ここがない🌟
    { id:'GetInformationHistory',        path:'/employee/historyemployees',          auth:'information'},//従業員履歴 ここがない🌟
    { id:'GetAssignedList',             path:'/employee/assigned/list',             auth:'assigned'},//出向社員(出)一覧
    { id:'GetMoveInList',               path:'/employee/movein/list',               auth:'moveIn'},//転入日一覧
    { id:'GetMoveOutList',              path:'/employee/moveout/list',              auth:'moveOut'},//転出日一覧
    { id:'GetAppointmentList',          path:'/employee/appointment/list',          auth:'appointment'},//新規任用・解任一覧
    { id:'GetOrganizationCodeList',     path:'/employee/organizationcode/list',     auth:'organizationCode'},//組織コード一覧
    { id:'GetDepartmentTransferList',   path:'/employee/departmenttransfer/list',   auth:'departmentTransfer'},//部署異動一覧
    { id:'GetAcceptedList',             path:'/employee/accepted/list',             auth:'accepted'},//出向社員(受)一覧
    { id:'GetTemporaryList',            path:'/employee/temporary/list',            auth:'temporary'},//派遣社員情報一覧
    { id:'GetContractList',             path:'/employee/contract/list',             auth:'contract'},//契約社員情報一覧
    { id:'GetCheckList',                path:'/employee/check/list',                auth:'check'},//従業員チェックリスト
    { id:'GetAllItemList',              path:'/employee/allitem/list',              auth:'allItem'},//従業員情報全項目一覧
    { id:'RegAllItem',                  path:'/employee/allitem/register',          auth:'allItem'},//従業員情報全項目登録
    { id:'UpdAllItem',                  path:'/employee/allitem/update',            auth:'allItem'},//従業員情報全項目編集
    { id:'OutAllItem',                  path:'/employee/allitem/output',            auth:'allItem'},//従業員情報全項目データ出力
    { id:'GetAuthorityList',            path:'/master/authority/list',              auth:'authority'},//権限グループマスタメンテ
    { id:'GetDepartmentList',           path:'/master/department/list',             auth:'department'},//部署マスタメンテ
    { id:'UpdDepartmentDetail',           path:'/master/department/update',             auth:'department'},//部署マスタ編集
    { id:'RegDepartmentDetail',           path:'/master/department/register',             auth:'department'},//部署マスタ登録
    { id:'GetDepartmentFormat',         path:'/master/department/format',           auth:'department'},//部署マスタマスタ一括編集
    { id:'GetStatusList',               path:'/master/status/list',                 auth:'status'},//雇用形態マスタメンテ
    { id:'GetGradeList',                path:'/master/grade/list',                  auth:'grade'},//等級マスタメンテ
    { id:'GetCostList',                 path:'/master/cost/list',                   auth:'cost'},//人件費区分マスタメンテ
    { id:'GetPositionList',             path:'/master/position/list',               auth:'position'},//役職マスタメンテ
    { id:'GetRankList',                 path:'/master/rank/list',                   auth:'rank'},//ランクマスタメンテ
    { id:'GetUserList',                 path:'/master/user/list',                   auth:'user'},//ユーザーマスタメンテ
];
/* ========= 日付チェックコードマスタ ========= */
export const dateCheckMaster = {
    name:'日付チェック',
    list:[
        {value: 'nowDate', label: '現在日時よりも新しい日時にしてください'},
        {value: 'oldDate', label: '現在日時よりも古い日時にしてください'}
    ]
};

/* ========= 入力チェックコードマスタ ========= */
export const inputCheckMaster = {
    name:'入力チェック',
    list:[
    {value: 'required', label: '必須'},//必須チェック
    {value: 'max', label: '桁数超過'},//桁数超過チェック
    {value: 'min', label: '桁数不足'},//桁数不足チェック
    {value: 'date', label: '日付不整合'},//日付の整合性チェック
    {value: 'keyword', label: '5個までキーワード検索可能'},//キーワード件数超過
    {value: 'invalidInput', label: '不正な入力値'}//不正な入力値(listに存在しない値を入力)

    ]
};
    
/* ========= パターンチェックコードマスタ ========= */    
export const patternCheckMaster = {
    name:'パターンチェック',
    list:[
        {value: 'script', label: '英数字のみ',detailItemValidationTypeCode:/^[0-9A-Za-z]+$/i},//数字・英大・英小
        {value: 'symbol', label: '英数字、-のみ',detailItemValidationTypeCode:/^[0-9A-Za-z--]+$/i},//数字・英大・英小・-
        {value: 'english', label: '英字のみ',detailItemValidationTypeCode:/^[A-Za-z]+$/i},//英大・英小
        {value: 'englishSpace', label: '英字・スペースのみ',detailItemValidationTypeCode:/^[A-Za-z]+[A-Za-z\s]*$/i},//数字・英大・英小
        {value: 'englishScript', label: '英数字、スぺース、-、.、,のみ',detailItemValidationTypeCode:/^[.0-9A-Za-z\s\-,]*$/i},//数字・英大・英小
        {value: 'space', label: 'スペースのみは不可',detailItemValidationTypeCode:/\S/i},//スペースのみ
        // {value: 'hankakuKatakana', label: '半角カナのみ',detailItemValidationTypeCode:/^[ｦ-ﾟ]+$/i},//半角カタカナのみ
        {value: 'zenkakuKatakana', label: '全角カナのみ',detailItemValidationTypeCode:/^[ァ-ー)]+$/i},//全角カタカナのみ
        {value: 'zenkakuKatakanaSpace', label: '全角カナ・スペースのみ',detailItemValidationTypeCode:/^[ァ-ー)]+[ァ-ー)\s]*$/i},//全角カタカナ・スペースのみ
        {value: 'number', label: '数字のみ',detailItemValidationTypeCode:/^\d*$/},//数字のみ
        {value: 'date', label: '日付不正',detailItemValidationTypeCode:/^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/},// yyyy-mm-ddのみ
        {value: 'dateTime', label: '日時不正',detailItemValidationTypeCode:/^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}$/},// yyyy-mm-ddTHH:MMのみ
        {value: 'mailAccount', label:'メールアカウント', detailItemValidationTypeCode:/^[.@0-9A-Za-z]+$/i},//メールアカウントのみ
        {value: 'workload', label:'フォーマットエラー', detailItemValidationTypeCode:/^([0-9]{1,2}|100):([0-9]{1,2}|100)$/i},//999:59
        {value: 'keyword', label:'使用不可な文字列', detailItemValidationTypeCode:/^[^'%_]*$/i}
    ]
};

/*====== ローカル・セッションストレージ用のキー ======*/
/*-----　ユーザー情報 -----*/
export const USERINFO_STORAGE = 'HRDB_userinfo';
/*----- フォントサイズ ------*/
export const FONTSIZE_STORAGE = 'HRDB_fontsize';
/*----- 権限 ------*/
export const AUTHORITY_STORAGE = 'HRDB_authority';
/*----- コード定義 ------*/
export const CODEDIFINITION_STORAGE = 'HRDB_codedifinition';
/*----- 年度リスト ------*/
export const YEAR_STORAGE = 'HRDB_year';
/*----- 一覧検索 ------*/
export const SEARCH_STORAGE = 'HRDB_search';
/*----- ソート情報(Excel出力用) ------*/
export const SORTINFO_STORAGE = 'HRDB_sortinfo';

// /*----- 値渡し用 ------*/
// export const PASSVALUE_STORAGE = 'HRDB_passvalue';
// /*----- 一覧(従業員)検索 ------*/
// export const E_SEARCH_STORAGE = 'HRDB_e_search';
// /*----- 画面遷移元 ------*/
// export const PATH_STORAGE = 'HRDB_path';
// /*----- urlパラメータ ------*/
// export const PARAMS_STORAGE = 'HRDB_params';
/*----- トークン ------*/
export const TOKEN_STORAGE = 'HRDB_token';
/*----- 認可トークン ------*/
export const AUTH_TOKEN = 'HRDB_authtoken';
/*----- 公開鍵 ------*/
export const PUBLIC_KEY = 'COM_publickey';